import groq from 'groq'
import { blocks, blocksV2025 } from '../blocks'
import { productCardGroq, productPageGroq } from '../utils/product'

export const getHomeGroq = groq`
*[_type == "home" 
  && context == $context
  && $lang in uid[]._key 
] {
  _id,
  _type,
  context,
  "uid": uid[_key == $lang][0].value,
  "title": title[_key == $lang][0].value,
  "alternate_languages": uid[_key != $lang],
  "description": description[_key == $lang][0].value,
  image {
    crop,
    image-> {
      _type,
      _id,
      path,
      dimensions
    }
  },
  ${blocks}
}`

export const getCollectionsGroq = groq`
*[_type == "collection" && $lang in uid[]._key] {
  _id,
  _type,
  context,
  "uid": uid[_key == $lang][0].value,
  "title": title[_key == $lang][0].value,
  "alternate_languages": uid[_key != $lang],
  "description": description[_key == $lang][0].value,
  image {
    crop,
    image-> {
      _type,
      _id,
      path,
      dimensions
    }
  },
  ${blocks}
}`

export const getCollectionGroq = groq`
*[_type == "collection" 
  && context == $context
  && $uid in uid[].value 
  && $lang in uid[]._key
] {
  _id,
  _type,
  context,
  "uid": uid[_key == $lang][0].value,
  "title": title[_key == $lang][0].value,
  "alternate_languages": uid[_key != $lang],
  "description": description[_key == $lang][0].value,
  image {
    crop,
    image-> {
      _type,
      _id,
      path,
      dimensions
    }
  },
  ${blocks}
}`

export const getProductsSoonSaleableGroq = groq`
*[
  _type == "product" 
  && status == "agenda"
  && dates.start > now() 
  && $lang in uid[]._key
  && context == $context
  && version != "variant"
] | order(dates.start desc) {
  ${productCardGroq}
}`

export const getProductsByShopifyIdsGroq = groq`
*[
  _type == "product"
  && shopify_product._ref in $ids
  && context == $context
  && $lang in uid[]._key
  && version != "variant"
]  {
  ${productCardGroq}
}`

export const getProductsUidByStatusAndContextGroq = groq`
*[
  _type == "product" 
  && status in $status
  && $lang in uid[]._key
  && version != "variant"
] {
  _id,
  "uid": uid[_key == $lang][0].value,
}
`

export const getProductsUidByShopifyIdsGroq = groq`
*[
  _type == "product" 
  && shopify_product._ref in $ids
  && $lang in uid[]._key
  && version != "variant"
] {
  _id,
  "uid": uid[_key == $lang][0].value,
  context,
}
`

export const getProductsByUidGroq = groq`
*[_type == "product" && count(uid[_key == $lang && value in $uids]) > 0] {
  ${productPageGroq},
  render_version == 'v2025' => {
    "blocks": ${blocksV2025}
  },
  render_version != 'v2025' => {
    "blocks": ${blocks}
  }
}
`

export const getProductGroq = groq`
*[
  _type == "product"
  && $uid in uid[].value 
  && $lang in uid[]._key
] {
  ${productPageGroq},
  render_version == 'v2025' => {
    "blocks": ${blocksV2025},
    blocks_gallery == null || count(blocks_gallery) == 0 => {
      "blocks_gallery": *[_id == "settings"] {
        default_product_blocks_gallery
      }[0].default_product_blocks_gallery
    }
  },
  render_version != 'v2025' => {
    "blocks": ${blocks}
  }
  
}
`

export const getProductBlockGroq = groq`
*[
  _type == "product"
  && $uid in uid[].value 
  && $lang in uid[]._key
] {
  ${blocks}
}
`

export const getProductBlockFor2025VersionGroq = groq`
*[
  _type == "product"
  && $uid in uid[].value 
  && $lang in uid[]._key
] {
  ${blocksV2025}
}
`

export const getSliderByIdGroq = groq`
*[
  _id == $id
] {
  ...,
  elements[] {
    ...,
    _type == 'slider_image' => {
      image {
        crop,
        image-> {
          ...,
        }
      }
    }
  }
}`
